import * as React from "react"

const SvgFolder = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 20.714q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 18.714v-12q0-.824.587-1.412A1.93 1.93 0 0 1 4 4.714h5.175a1.98 1.98 0 0 1 1.4.575L12 6.714h8q.824 0 1.413.588.587.587.587 1.412v10a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm0-2h16v-10h-8.825l-2-2H4z" />
  </svg>
)
export default SvgFolder
